import { useState, useEffect } from "react";
import { api } from "./api";

export function useContent(section, fallback = []) {
  const [data, setData] = useState(fallback);
  useEffect(() => {
    let alive = true;
    api.get(`/content/${section}`).then(({ data }) => {
      if (alive && Array.isArray(data) && data.length) setData(data);
    }).catch(() => {});
    return () => { alive = false; };
  }, [section]);
  return data;
}

export function useNosotros(fallback) {
  const [data, setData] = useState(fallback);
  useEffect(() => {
    let alive = true;
    api.get("/content/nosotros").then(({ data }) => {
      if (alive && data && (data.lead || (data.blocks || []).length)) setData(data);
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return data;
}

export const FOOTER_DEFAULTS = {
  description: "50 años de pasión, identidad y comunidad. Un club hecho por su gente, para su gente.",
  address: "Av. del Club 1976, Sede Social — Argentina",
  phone: "+540000000000",
  phone_display: "+54 (000) 000-0000",
  email: "info@clubleonowak.com.ar",
  hours: "Lun a Sáb · 9 a 22 h",
  whatsapp: "5490000000000",
  whatsapp_sponsors: "5490000000000",
  instagram: "",
  facebook: "",
  youtube: "",
};

export function useFooter() {
  const [data, setData] = useState(FOOTER_DEFAULTS);
  useEffect(() => {
    let alive = true;
    api.get("/content/footer").then(({ data }) => {
      if (alive && data) setData({ ...FOOTER_DEFAULTS, ...data });
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return data;
}
